import { TextField } from "@material-ui/core";
import withStyles from "@material-ui/core/styles/withStyles";

export const CustomTextField = withStyles((theme) => ({}))(TextField);
